module.exports = __webpack_public_path__ + "img/9-kooien.ff8fb77b.jpg";